import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/permissions';
import { ResultState } from '@rootCommon/types/common';
import { Permission } from '@rootCommon/types/permission';

type Action = ActionType<typeof actions>;
export type PermissionsState = ResultState<Permission[] | null>;

const initState: PermissionsState = {
  data: null,
  loading: false,
  error: null,
};

export const permissionsReducer = (state = initState, action: Action): PermissionsState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchPermissions.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchPermissions.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchPermissions.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default permissionsReducer;
